import cx from "classnames"
import React from "react"

import type { MarginBottomSize, GapSize } from "./types"

import styles from "./index.module.css"
import { GAP_SIZES, MARGIN_BOTTOM_SIZES } from "./types"

interface ContainerProps {
  children: React.ReactNode
  /**
   * Number of grid columns.
   */
  grid?: number

  /**
   * The gap size between grid items.
   */
  gap?: GapSize
  /**
   * Bottom margin size.
   */
  mb?: MarginBottomSize

  /**
   * Whether the container is inner content.
   */
  inner?: boolean
  /**
   * Maximum width of the container.
   */
  maxWidth?: number
}

export const Container = ({ children, grid, gap = "m", mb, inner, maxWidth }: ContainerProps) => {
  const gridStyle = grid ? { gridTemplateColumns: `repeat(${grid}, 1fr)` } : {}
  const mbClass = mb ? styles[MARGIN_BOTTOM_SIZES[mb]] : ""
  const gapClass = gap ? styles[GAP_SIZES[gap]] : ""
  const maxWidthStyle = maxWidth ? { maxWidth: `${maxWidth}px` } : {}

  const containerClassNames = cx(styles.container, styles.grid, mbClass, gapClass, {
    [styles.inner]: inner,
  })

  return (
    <div className={containerClassNames} style={{ ...gridStyle, ...maxWidthStyle }}>
      {children}
    </div>
  )
}
